import styled from 'styled-components/macro';
import { TextInput, textStyles } from '../../LoginPage/LoginPage.styles';

export const PhoneInputFieldWrapper = styled.div`
  ${textStyles}
`;

export const PhoneInputComponent = styled(TextInput)`
  && {
    margin-top: 0;
  }
`;

export const Error = styled.div`
  text-align: left;
  color: red;
  font-style: normal;
  font-size: 10px;
  line-height: 12px;
  margin: 4px 0 0 0;
  background-image: url('/images/error-esclamation.svg');
  background-repeat: no-repeat;
  background-position: center left;
  padding-left: 14px;
  background-size: 10px;
`;
